import {
  Component,
  ElementRef,
  input,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'app-select2-option',
  templateUrl: './select2-option.component.html',
  host: { class: 'block min-w-0', '(mouseenter)': 'updateTooltipVisibility()' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class Select2OptionComponent {
  readonly label = input<string>();

  private readonly labelElement =
    viewChild.required<ElementRef<HTMLElement>>('optionLabel');
  private readonly tooltip = viewChild.required(TooltipDirective);

  updateTooltipVisibility() {
    const { scrollWidth, clientWidth } = this.labelElement().nativeElement;
    // Set directly: the tooltip reads it right after mouseenter, before a template binding would refresh
    this.tooltip().visibleTooltip = scrollWidth > clientWidth;
  }
}
